import { render, staticRenderFns } from "./CrmBoard.vue?vue&type=template&id=4df91006"
import script from "./CrmBoard.vue?vue&type=script&lang=js"
export * from "./CrmBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports